"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecommendationRow = RecommendationRow;
exports.RecommendationContact = RecommendationContact;
exports.RecommendationFile = RecommendationFile;
exports.RecommendationPhoto = RecommendationPhoto;
exports.NoResults = NoResults;
exports.RecommendationContainer = RecommendationContainer;
exports.Recommendation = Recommendation;
exports["default"] = exports.attachmentsType = exports.RecommendationRowContainer = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _styles = require("@material-ui/core/styles");

var _HorizontalList = _interopRequireDefault(require("../HorizontalList"));

var _AttachmentIcon = _interopRequireDefault(require("../AttachmentIcon"));

var _utils = require("../../utils");

var _constants = require("../../utils/constants");

var Recommendations = function Recommendations(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-full"
  }, children);
};

var RecommendationRowContainer = function RecommendationRowContainer(props) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: "flex items-center justify-center flex-wrap px-8 py-4 mb-5 last:mb-0 last:pt-0"
  }));
};
/**
 * Handles each row of recommendations.
 *
 * @public
 */


exports.RecommendationRowContainer = RecommendationRowContainer;
var HEIGHT = 230;
var COLUMN_WIDTH = 270;

function RecommendationRow(_ref2) {
  var children = _ref2.children;

  var count = _react["default"].Children.count(children);

  var nodes = _react["default"].Children.toArray(children);

  return /*#__PURE__*/_react["default"].createElement(RecommendationRowContainer, null, /*#__PURE__*/_react["default"].createElement(_HorizontalList["default"], {
    invert: false,
    count: count,
    height: HEIGHT,
    rowHeight: HEIGHT,
    columnWidth: COLUMN_WIDTH,
    enablePagination: false,
    cellRenderer: function cellRenderer(_ref3) {
      var key = _ref3.key,
          columnIndex = _ref3.columnIndex,
          style = _ref3.style;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: key,
        style: style
      }, nodes[columnIndex]);
    }
  }));
}
/**
 * Wrapper for each item inside a recommendation row.
 *
 * @public
 */


function RecommendationItem(_ref4) {
  var children = _ref4.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref4, ["children"]);

  var _useTheme = (0, _styles.useTheme)(),
      palette = _useTheme.palette;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-3 w-full h-48"
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "h-full cursor-pointer bg-card dark:shadow-lg",
    style: {
      boxShadow: palette.type === _constants.themeMode.DARK ? undefined : '0px 5px 20px #0000000A'
    }
  }, rest), children));
}

function RecommendationContact(_ref5) {
  var name = _ref5.name,
      email = _ref5.email,
      avatar = _ref5.avatar,
      rest = (0, _objectWithoutProperties2["default"])(_ref5, ["name", "email", "avatar"]);
  return /*#__PURE__*/_react["default"].createElement(RecommendationItem, rest, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center w-full h-full p-5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-5 recommendation-contact-avatar"
  }, avatar), /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 text-xs"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold truncate text-dark"
  }, name), /*#__PURE__*/_react["default"].createElement("p", {
    className: "truncate text-medium"
  }, email))));
}

function RecommendationFile(_ref6) {
  var name = _ref6.name,
      from = _ref6.from,
      contentType = _ref6.contentType,
      rest = (0, _objectWithoutProperties2["default"])(_ref6, ["name", "from", "contentType"]);
  var type = (0, _utils.getAttachmentType)(contentType, name);
  return /*#__PURE__*/_react["default"].createElement(RecommendationItem, rest, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-center items-center w-full h-full p-5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-1 items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_AttachmentIcon["default"], {
    colored: true,
    contentType: contentType,
    fontSize: "large",
    fileName: name
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 w-full text-center text-xs"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold truncate text-dark"
  }, name), from && /*#__PURE__*/_react["default"].createElement("p", {
    className: "truncate text-medium"
  }, from), /*#__PURE__*/_react["default"].createElement("p", {
    className: "uppercase truncate text-medium"
  }, type))));
}

function RecommendationPhoto(_ref7) {
  var thumbnail = _ref7.thumbnail,
      from = _ref7.from,
      name = _ref7.name,
      contentType = _ref7.contentType,
      rest = (0, _objectWithoutProperties2["default"])(_ref7, ["thumbnail", "from", "name", "contentType"]);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var thumbnailNode = (0, _utils.isImage)(contentType, name) ? thumbnail : /*#__PURE__*/_react["default"].createElement("img", {
    className: "w-full",
    src: t('placeholder-photo.png'),
    alt: "Placeholder"
  });
  return /*#__PURE__*/_react["default"].createElement(RecommendationItem, rest, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-center w-full h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full flex-1 recommendation-photo-thumbnail"
  }, thumbnailNode), /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 w-full text-center p-5 text-xs"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold truncate text-dark"
  }, name), from && /*#__PURE__*/_react["default"].createElement("p", {
    className: "truncate text-medium"
  }, from))));
}

function NoResults() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-xl px-13 font-bold text-dark"
  }, t('search.recommendations.noResults.title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-light px-13 mb-2 text-sm"
  }, t('search.recommendations.noResults.message')));
}

var attachmentsType = {
  file: 'file',
  image: 'image'
};
exports.attachmentsType = attachmentsType;

function RecommendationContainer(props) {
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid px-12 grid-cols-5 gap-8"
  }, children);
}

function Recommendation(props) {
  var file = props.file,
      onClick = props.onClick,
      index = props.index,
      thumbnail = props.thumbnail;

  if (file.attachmentsType === attachmentsType.file) {
    return /*#__PURE__*/_react["default"].createElement(RecommendationFile, (0, _extends2["default"])({
      key: "".concat(file.id, "-").concat(index)
    }, file, {
      onClick: onClick
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(RecommendationPhoto, (0, _extends2["default"])({
    key: "".concat(file.id, "-").concat(index)
  }, file, {
    thumbnail: thumbnail,
    onClick: onClick
  }));
}

var _default = Recommendations;
exports["default"] = _default;
//# sourceMappingURL=Recommendations.js.map